import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import moment from 'moment'
import type { MapLayer } from 'tripPlanner/contexts/MapLayers/MapLayersContext'
import type { CustomPlace, GeoPlace } from 'tripPlanner/types/common'

interface PlaceItem {
  place?: GeoPlace
  startPlace?: GeoPlace
}

export function hasValidPlace(item: PlaceItem): boolean {
  return Boolean(
    ('place' in item && hasGeoPlace(item.place)) ||
    ('startPlace' in item && hasGeoPlace(item.startPlace)),
  )
}

export function hasGeoPlace(place: GeoPlace | CustomPlace | undefined): boolean {
  return (
    place?.type === 'GEO' &&
    typeof place.point?.lat === 'number' &&
    typeof place.point?.lng === 'number'
  )
}

export function isDateLayerVisible(layerGroups: Array<{ id: string, layers: Array<MapLayer> }>, date?: string): boolean {
  if (!date) return true

  const itineraryGroup = layerGroups.find(group => group.id === 'itinerary')
  if (!itineraryGroup) return true

  const matchingLayer = itineraryGroup.layers.find(
    (layer) => moment(layer.id).format(ISO_DATE_FORMAT) === date,
  )

  return matchingLayer?.isSelected ?? true
}
